module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../~/_core-js@2.6.9@core-js/library/modules/_add-to-unscopables.js
// module id = 1012
// module chunks = 0